import type { ModeType } from "../../";

export function invertTheme( theme: ModeType ) {
    return theme === "light" ? "dark" : "light";
}